module.exports = __webpack_public_path__ + "static/img/patho-erosion-medium-D74Ibq03.7fa6c81b.png";